import {
  getSubscriptionById,
  getUserSubscriptions
} from "./chunk-A4ATQWYG.mjs";
import {
  __spreadValues
} from "./chunk-RGHW4PYM.mjs";

// src/hooks/wbk/subscriptions/user.ts
import { useQuery } from "@tanstack/react-query";
var useGetSubscriptionById = (props) => {
  return useQuery({
    queryKey: ["getSubscriptionById", props],
    queryFn: () => getSubscriptionById(props)
  });
};
var useGetUserSubscriptions = (props, options) => {
  return useQuery(__spreadValues({
    queryKey: ["getUserSubscriptions", props],
    queryFn: () => getUserSubscriptions(props),
    staleTime: Infinity
  }, options));
};

export {
  useGetSubscriptionById,
  useGetUserSubscriptions
};
//# sourceMappingURL=chunk-YKKEAOL2.mjs.map